import { createSelector, createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { activeFreeShippingProgressBarAtbSelector } from 'viewModel/selectors/testTarget/activeFreeShippingProgressBarAtbSelector';

const { wrapHOC } = FrameworkUtils;

const isFreeShippingProgressBarAtbActiveSelector = createSelector(
    activeFreeShippingProgressBarAtbSelector,
    ({ challengerOne, challengerTwo }) => challengerOne || challengerTwo
);

/**
 * Selector that maps Redux state to `BasketMobile` props for the Free
 * Shipping Progress Bar ATB experiment.
 *
 * @param {object} state Redux state.
 * @returns {{
 *   isFreeShippingProgressBarAtbActive: boolean,
 *   freeShippingProgressBarAtbExperience: {challengerOne: boolean, challengerTwo: boolean}
 * }}
 */
const fields = createStructuredSelector({
    isFreeShippingProgressBarAtbActive: isFreeShippingProgressBarAtbActiveSelector,
    freeShippingProgressBarAtbExperience: activeFreeShippingProgressBarAtbSelector
});

/**
 * HOC that connects `BasketMobile` to the Free Shipping Progress Bar ATB
 * experiment selectors via Redux.
 *
 * @param {React.ComponentType} WrappedComponent Component to enhance.
 * @returns {React.ComponentType} Component with `isFreeShippingProgressBarAtbActive`
 *   and `freeShippingProgressBarAtbExperience` injected as props.
 */
const withBasketMobileProps = wrapHOC(connect(fields));

export {
    withBasketMobileProps, fields
};
